import React from "react";
import Cookies from "js-cookie";
import { decode as base64_decode } from "base-64";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  message,
  Modal,
  Form,
  Select,
  DatePicker,
  Tooltip,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import { DeleteFilled, SearchOutlined } from "@ant-design/icons";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import WASLDriverStore from "../store/WASLDriverStore";
import DeleteConfirm from "./DeleteConfirm";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import dayjs from "dayjs";
import CountryStore from "../store/CountryStore";
const dateFormat = "YYYY-MM-DD";
const { Option } = Select;

class WASLDriverList extends React.Component {
  constructor(props) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.waslDriverStore = new WASLDriverStore(this);
    this.companyStore = new CompanyStore();
    this.countryStore = new CountryStore(this);

    this.state = {
      showWASLRegistration: false,
      loading: false,
      pageSize: 50,
      limit: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      Company: true,
      Individual: false,
      cname: "",
      identityNo: "",
      crNo: "",
      loadData: 0,
      companyId: "",
      vehicleId: "",
      showAlertModal: false,
      searchField: "",
      currentPage: 1,
    };
    this.formRef = React.createRef();

    this.ExportMenuProps = {
      items: [
        {
          label: "Excel",
          key: "excel",
        },
      ],
      onClick: (val) => {
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));
        var getData = {
          cid: this.state.companyId,
          UcompanyId: JSON.parse(base64_decode(Cookies.get("data"))).UcompanyId,
          searchField: this.state.searchField,
          colList: result,
        };
        if (val.key == "excel") {
          this.waslDriverStore.exportExcel(getData);
        }
      },
    };
  }
  async componentDidMount() {
    await this.setState({ pageSize: 50 });
    await this.handleSearch();
    await this.countryStore.getCountry();
    await this.setState({ loadData: 1 });
    this.columns = [
      {
        // title: "Account",
        title: this.context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
        dataIndex: "companyName",
        key: "account",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "Driver",
        title: this.context.translate(
          "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
        ),
        dataIndex: "driverName",
        key: "driverName",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "Identity Number",
        title: this.context.translate("_IDENTITY_NUMBER_"),
        dataIndex: "identityNo",
        key: "identityNo",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "DOB",
        title: this.context.translate("_DOB_"),
        dataIndex: "dob",
        key: "dob",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "Mobile No",
        title: this.context.translate(
          "_FLEET_DASHBORD_VEHICLE_INFORMATION_MOBILE_"
        ),
        dataIndex: "mobileNo",
        key: "mobileNo",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "WASL Driver Key",
        title: this.context.translate("_WASL_DRIVER_KEY_"),
        dataIndex: "waslDriverKey",
        key: "waslDriverKey",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "Activity",
        title: this.context.translate("_ACTIVITY_"),
        dataIndex: "activity",
        key: "activity",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "Response",
        title: this.context.translate("_RESPONSE_"),
        dataIndex: "response",
        key: "response",
        width: 15,
        ellipsis: true,
      },
      {
        // title: "Reply",
        title: this.context.translate("_REPLY_"),
        dataIndex: "reply",
        key: "reply",
        width: 15,
        ellipsis: true,
      },
      {
        title: this.context.translate("_ACTION_"),
        dataIndex: "Action",
        fixed: "right",
        width: 5,
        ellipsis: true,
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  // title="WASL Status"
                  title={this.context.translate("_WASL_STATUS_")}
                  color={config.tooltipColorEdit}
                >
                  {/* <SearchOutlined
                    onClick={async () => {
                      await this.WASLDriverStatus(record);
                      await this.setState({ showAlertModal: true });
                    }}
                  /> */}
                  <SearchOutlined
                    onClick={async () => {
                      const response =
                        await this.waslDriverStore.getWASLDriverStatus(record);

                      if (response) {
                        this.setState({
                          waslInquiryPopup: true,
                          showAlertModal: false,
                          loadData: 1,
                        });
                      } else {
                        this.setState({
                          waslInquiryPopup: false,
                          showAlertModal: true,
                          loadData: 1,
                        });
                      }
                    }}
                  />
                </Tooltip>
                <DeleteConfirm
                  onConfirm={(e) => {
                    this.onDelete(record);
                  }}
                >
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <Tooltip
                      // title="Delete Record"
                      title={this.context.translate("_DELETE_RECORD_")}
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm>
              </Space>
            </>
          );
        },
      },
    ];
  }

  // WASLDriverStatus = async (record) => {
  //   await this.waslDriverStore.getWASLDriverStatus({ Id: record.Id });
  // };

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    if (comp) {
      await this.setState({ companyId: comp.value, loadList: 1 });

      await this.handleSearch();
      await this.setState({ loadData: 1 });
    } else {
      await this.setState({ companyId: null });
      await this.handleSearch();

      await this.setState({ loadData: 1 });
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.waslDriverStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      UcompanyId:
        this.props.getUserData().isadmin === 3
          ? this.props.getUserData().userCompanyId
          : 0,
      pageNo: this.state.currentPage,
    });
    await this.setState({ loadList: 1 });
    // this.setState({ loading: false });
  }

  onWASLRegistrationFinish = async (value) => {
    const data = {
      ...value,
      userId: 1,
      companyId: this.state.companyId,
      dob: value?.dob?.format(dateFormat),
    };
    const response = await this.waslDriverStore.registerDriver(data);
    if (response?.success === "S") {
      message.success(response.data.message);
      await this.handleSearch();
    } else {
      message.error(response.data.message);
    }
    if (response.data.message) {
      this.setState({ showWASLRegistration: false });
      this.formRef.current?.resetFields();
    }
  };

  setFieldsValues = async (vehicleId) => {
    const data = await this.waslDriverStore.getDriverInfo(vehicleId);

    await this.formRef.current.setFieldsValue({ dobFormat: data.dobFormat });
    await this.formRef.current.setFieldsValue({ mobileNumber: data.mobileno });
    await this.formRef.current.setFieldsValue({
      identityNumber: data.licensenumber,
    });

    await this.formRef.current.setFieldsValue({
      dob: data.dob ? dayjs(data.dob, "YYYY-MM-DD") : null,
    });
  };

  async onDelete(record) {
    const response = await this.waslDriverStore.deleteRecord({
      Id: record.Id,
      companyId: record.companyId,
      waslDriverKey: record.waslDriverKey,
      userId: this.props.getUserData().userId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async companySearch(companyId) {
    await this.waslDriverStore.toGetDriverName(companyId.value);

    await this.waslDriverStore.getCompanyIdentityNo(companyId.value);

    await this.setState({ loadList: 1 });
  }

  searchInput = async (e) => {
    const value = e.target.value;

    await this.setState({ searchField: value });
    if (value.length > 2) {
      await this.waslDriverStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1, companyLoading: false });
    } else if (value.length === 0) {
      await this.waslDriverStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({
        loadList: 1,
        companyLoading: false,
        currentPage: 1,
      });
    }
  };

  validatePhoneNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  render() {
    const {
      referenceKey,
      name,
      registrationTime,
      criminalRecordStatus,
      operatingCompanies,
      rejectionReasons,
    } = this.waslDriverStore?.inquiryStatus || {};

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Space>
              <CompanyAutocomplete
                allowClear={true}
                onChange={(value) => this.handleChange(value)}
                style={{ width: 200 }}
              />

              <Input
                style={{ width: 400 }}
                value={this.state.searchField ? this.state.searchField : ""}
                placeholder={this.context.translate(
                  "_Search_By_Driver_Name_Driver_Identity_Number_"
                )}
                onChange={async (e) => {
                  await this.setState({ searchField: e.target.value });
                  await this.searchInput(e);
                }}
              ></Input>

              {/* <Button
                type="primary"
                onClick={async () => {
                  await this.waslDriverStore.loadData({
                    offset: 0,
                    limit: this.state.pageSize,
                    searchField: this.state.searchField,
                    companyId: this.state.companyId,
                  });
                  // await this.onSearch()
                  await this.setState({ loadData: 1 });
                }}
              >
                <SearchOutlined />
              </Button> */}
            </Space>
            <Space
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Link to={"/companydriverslist"}>
                <Button className="addButtonClass">
                  {this.context.translate("_BACK_")}
                </Button>
              </Link>
              <Button
                className="addButtonClass"
                onClick={() => this.setState({ showWASLRegistration: true })}
              >
                <Image
                  style={{ marginInlineEnd: "5px", width: 13 }}
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                />
                {this.context.translate("_REGISTER_")}
              </Button>

              <Button
                className="downloadExcelButton"
                disabled={
                  this.waslDriverStore?.WASLDriverArray.length > 0
                    ? false
                    : true
                }
                onClick={async () => {
                  const result = [];
                  this.columns.map((obj) => result.push(obj.dataIndex));
                  var getData = {
                    cid: this.state.companyId,
                    UcompanyId: JSON.parse(base64_decode(Cookies.get("data")))
                      .UcompanyId,
                    searchField: this.state.searchField,
                    colList: result,
                  };

                  this.waslDriverStore.exportExcel(getData);
                }}
              >
                <Tooltip title="Download Excel" placement="bottom">
                  <Image
                    style={{
                      height: 18,
                      width: "auto",
                    }}
                    src={downloadIcon}
                  />
                </Tooltip>
              </Button>
            </Space>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.waslDriverStore?.total}
            columns={this.columns}
            dataSource={this.waslDriverStore?.WASLDriverArray}
            loading={this.waslDriverStore?.loading}
            onChange={this.handleTableChange}
          />

          {/* <Modal
            title={this.context.translate("_WASL_REGISTRATION_")}
            open={this.state.showWASLRegistration}
            onCancel={() => this.setState({ showWASLRegistration: false })}
            footer={null}
            width={665}
            style={{
              top: 20,
            }}
          > */}
          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            open={this.state.showWASLRegistration}
            placement={
              this.context.locale.language === "english" ? "right" : "left"
            }
            title={
              <div className="formTitle">
                {this.context.translate("_WASL_REGISTRATION_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_ADD_DESC_")}
                </p>
              </div>
            }
            footer={false}
            maskClosable={false}
            onOk={() => this.setState({ showWASLRegistration: false })}
            onCancel={() =>
              this.setState({
                showWASLRegistration: false,
              })
            }
          >
            <Form
              ref={this.formRef}
              layout="vertical"
              name="companyFrm"
              onFinish={this.onWASLRegistrationFinish}
              style={{ maxWidth: "100%", padding: 0, height: "92%" }}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="waslFormClass">
                  <Form.Item
                    className="formFieldsStyle"
                    name="companyId"
                    label={
                      <span>
                        {this.context.translate("_ACCOUNT_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <CompanyAutocomplete
                      onChange={(companyId) => {
                        this.setState({ companyId: companyId.value });
                        this.companySearch(companyId);
                        this.formRef.current.setFieldsValue({
                          driverId: undefined,
                        });
                        this.waslDriverStore.toGetDriverName(companyId.value);
                        this.waslDriverStore.getCompanyIdentityNo(
                          companyId.value
                        );
                      }}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="cidentityNo"
                    label={
                      <span>
                        {this.context.translate("_COMPANY_IDENTITY_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_COMPANY_IDENTITY_NUMBER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      placeholder={this.context.translate(
                        "_SELECT_COMPANY_IDENTITY_NUMBER_"
                      )}
                      name="cidentityNo"
                      showSearch
                      fieldNames={{
                        value: "identityNo",
                        label: "identityActivity",
                      }}
                      optionFilterProp="children"
                      options={this.waslDriverStore?.CompanyIdentityNumbers}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="driverId"
                    label={
                      <span>
                        {this.context.translate("_DRIVER_NAME_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_DRIVER_NAME_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      placeholder={this.context.translate("_SELECT_DRIVER_")}
                      name="driverId"
                      onChange={(e) => this.setFieldsValues(e)}
                      showSearch
                      fieldNames={{ value: "driverId", label: "name" }}
                      optionFilterProp="children"
                      options={this.waslDriverStore?.WASLDriverName}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="identityNumber"
                    label={
                      <span>
                        {this.context.translate("_IDENTITY_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_IDENTITY_NUMBER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="dobFormat"
                    label={
                      <span>
                        {this.context.translate("_DOB_FORMATE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_DOB_FORMATE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select>
                      <Select.Option value="Hijri">
                        {this.context.translate("_HIJRI_")}
                      </Select.Option>
                      <Select.Option value="Gregorian">
                        {this.context.translate("_GREGORIAN_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12} className="waslFormClass">
                  <Form.Item
                    name="dob"
                    className="formFieldsStyle"
                    label={
                      <span>
                        {this.context.translate("_DOB_LABEL_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_DOB_LABEL_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px" }}
                      format={dateFormat}
                    />
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    label={
                      <span>
                        {this.context.translate("_MOBILE_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_MOBILE_NUMBER_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        name="countryCode"
                        noStyle
                        initialValue={config.countryCode}
                      >
                        <Select
                          style={{ width: "55%", borderRadius: "5px" }}
                          showSearch
                          filterOption={(inputValue, option) => {
                            if (option.children) {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }
                          }}
                        >
                          {this.countryStore?.country?.map((country) => {
                            return (
                              <Option
                                value={parseInt(country.countryId)}
                                key={country.countryId}
                              >
                                {country.countryCode}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="mobileNumber"
                        noStyle
                        rules={[
                          {
                            required: true,
                            pattern: /^\d{8,10}$/,
                            message: this.context.translate(
                              "_Enter_7_or_10_Digit_Number_"
                            ),
                          },
                        ]}
                        required={false}
                      >
                        <Input
                          style={{ width: "100%" }}
                          onChange={(e) =>
                            this.validatePhoneNumber(
                              e.target.value,
                              "mobileNumber"
                            )
                          }
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Form.Item
                      style={{ width: "30%" }}
                      name="countryCode"
                      // label="Contact 1"
                      label={" "}
                      // rules={[{ required: true }]}
                      rules={[{ required: true }]}
                      initialValue={+966}
                    >
                      <Select>
                        <Select.Option value={91}>+91</Select.Option>
                        <Select.Option value={966}>+966</Select.Option>

                        <Select.Option value={971}>+971</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      style={{ width: "65%" }}
                      name="mobileNumber"
                      // label="Phone Number 1"
                      label={this.context.translate("_MOBILE_NUMBER_")}
                      rules={[
                        {
                          required: true,
                          pattern: /^(\d{7}|\d{10})$/,
                          // message: "Enter a 7 or 10 digit number",
                          message: this.context.translate(
                            "_Enter_7_or_10_Digit_Number_"
                          ),
                        },
                      ]}
                      // rules={[{ required: true}]}
                    >
                      <Input
                        onChange={(e) =>
                          this.validatePhoneNumber(
                            e.target.value,
                            "mobileNumber"
                          )
                        }
                      />
                    </Form.Item>
                  </div> */}

                  <Form.Item
                    className="formFieldsStyle"
                    name="registerType"
                    label={
                      <span>
                        {this.context.translate("_REGISTRATION_TYPE_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_REGISTRATION_TYPE_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select
                      placeholder={this.context.translate("_SELECT_TYPE_")}
                    >
                      <Select.Option value="1">
                        {this.context.translate(
                          "_FLEET_DASHBORD_NEWPOI_COMPANY_"
                        )}
                      </Select.Option>
                      <Select.Option value="2">
                        {this.context.translate("_INDIVIDUAL_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    className="formFieldsStyle"
                    name="waslDriverActivity"
                    initialValue={"DEFAULT"}
                    label={
                      <span>
                        {this.context.translate("_ACTIVITY_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_ACTIVITY_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Select>
                      <Select.Option value="DEFAULT">
                        {this.context.translate("_DEFAULT_")}
                      </Select.Option>

                      <Select.Option value="TOW_CAR">
                        {this.context.translate("_TOW_CAR_")}
                      </Select.Option>
                      <Select.Option value="SPECIALITY_TRANSPORT">
                        {this.context.translate("_SPECIALITY_TRANSPORT_")}
                      </Select.Option>
                      <Select.Option value="BUS_RENTAL">
                        {this.context.translate("_BUS_RENTAL_")}
                      </Select.Option>
                      <Select.Option value="EDUCATIONAL_TRANSPORT">
                        {this.context.translate("_EDUCATIONAL_TRANSPORT_")}
                      </Select.Option>
                      <Select.Option value="SFDA">
                        {this.context.translate("_SFDA_")}
                      </Select.Option>
                      <Select.Option value="INTERNATIONAL_TRANSPORT">
                        INTERNATIONAL TRANSPORT
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => {
                    this.setState({ showWASLRegistration: false });
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button htmlType="submit" className="formsSaveButton">
                  {this.context.translate("_REGISTER_")}
                </Button>
              </div>
            </Form>
          </Drawer>
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showAlertModal}
          onOk={() => this.setState({ showAlertModal: false })}
          onCancel={() => this.setState({ showAlertModal: false })}
          okText="OK"
          cancelText="Cancel"
          footer={[
            <Button
              type="primary"
              onClick={() => this.setState({ showAlertModal: false })}
            >
              {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
            </Button>,
          ]}
        >
          <p>{this.waslDriverStore?.WASLDriverStatus}</p>
        </Modal>

        <Modal
          width={550}
          className="alert-model"
          title={this.context.translate("_INFORMATION_")}
          open={this.state.waslInquiryPopup}
          onOk={() => this.setState({ waslInquiryPopup: false })}
          onCancel={() => this.setState({ waslInquiryPopup: false })}
          okText="OK"
          cancelText="Cancel"
          footer={null}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_REFERENCE_KEY_")}:</b>
              <span>{referenceKey}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_FLEET_USER_USERLIST_NAME_")}:</b>
              <span>{name}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_REGISTRATION_TIME_")}:</b>
              <span>{registrationTime}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_CRIMINAL_RECORD_STATUS_")}:</b>
              <span>{criminalRecordStatus}</span>
            </div>
            {this.context.translate("_OPERATING_COMPANY_INFORMATION_")}:
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_OPERATING_COMPANY_NAME_")}:</b>
              <span>
                {
                  this.waslDriverStore?.inquiryStatus?.operatingCompanies[0]
                    ?.operatingCompanyName
                }
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_IS_DRIVER_VALID_")}:</b>
              <span>
                {this.waslDriverStore?.inquiryStatus?.operatingCompanies[0]
                  ?.isDriverValid
                  ? "True"
                  : "False"}
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>{this.context.translate("_REJECTION_REASON_")}:</b>
              <span>{rejectionReasons}</span>
            </div>
          </div>
          {/* <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <b>Reference Key:</b>
                      <span>123456789</span>
                    </div>
        
                    <b>Plate Information:</b>
                    <span>Right Letter: A</span>
                    <span>Middle Letter: B</span>
                    <span>Left Letter: C</span>
                    <span>Number: 1234</span>
                    <span>Vehicle IMEI: 3570729292929</span>
        
                    <h6>Vehicle Location Information:</h6>
                    <span>Latitude: 25.2048</span>
                    <span>Longitude: 55.2708</span>
                    <span>Vehicle Status: Active</span>
                    <span>Actual Time: 2025-10-16 12:30:00</span>
                    <span>Received Time: 2025-10-16 12:31:10</span>
        
                    <h6>Operating Company Information:</h6>
                    <span>Reference Key: 987654321</span>
                    <span>Name: SecureTrack</span>
                    <span>Is Vehicle Valid: Yes</span>
                    <span>Registration Time: 2024-12-20 09:15:00</span>
                  </div> */}
        </Modal>
      </>
    );
  }
}
WASLDriverList.contextType = StoreContext;
export default observer(withRouter(WASLDriverList));
